import useHasura from '@/hooks/useHasura'

import { GET_BASKET_BY_ID } from '../queries/customers/getBasketById'

function useBasket(id: number) {
  const { data, ...rest } = useHasura<any>('basket', GET_BASKET_BY_ID, {
    variables: { id },
  })

  return { basket: data?.baskets?.[0], ...rest }
}

export default useBasket
